import {keysToCamel} from "../../helpers/utils"

export const MODULE_NAME = "USER"

// -------------- State -------------- //
const defaultState = () => ({
  subscriptionData: null,
  userData: null,
})


const state = defaultState()

// -------------- Mutations -------------- //
const MUTATIONS_TYPES = {
  SET_USER_DATA: "SET_USER_DATA",
  SET_SUBSCRIPTION_DATA: "SET_SUBSCRIPTION_DATA",
  CLEAN_USER_STATE: "CLEAN_USER_STATE",
}

const mutations = {
  [MUTATIONS_TYPES.CLEAN_USER_STATE](state) {
    Object.assign(state, defaultState())
  },
  [MUTATIONS_TYPES.SET_SUBSCRIPTION_DATA](state, subscriptionData) {
    state.subscriptionData = subscriptionData
  },
  [MUTATIONS_TYPES.SET_USER_DATA](state, userData) {
    state.userData = userData
  },
  [MUTATIONS_TYPES.SET_SUBSCRIPTION_DATA](state, subscriptionData) {
    state.subscriptionData = subscriptionData
  },
}

// -------------- Getters -------------- //
export const GET_IS_INTL = "GET_IS_INTL"
export const GET_USER_DATA = "GET_USER_DATA"
export const GET_SUBSCRIPTION_DATA = "GET_SUBSCRIPTION_DATA"
export const GET_HAS_REGISTER_COMPLETE = "GET_HAS_REGISTER_COMPLETE"

const getters = {
  [GET_IS_INTL](state) {
    if (!state.userData || !state.userData.abCountry) {
      return false
    }
    return state.userData.abCountry.toLowerCase() !== "br"
  },
  [GET_USER_DATA](state) {
    return state.userData
  },
  [GET_SUBSCRIPTION_DATA](state) {
    return state.subscriptionData
  },
  [GET_HAS_REGISTER_COMPLETE](state) {
    if (!state.userData) {
      return false
    }
    return state.userData.blRegisterComplete
  },
}

// -------------- Actions -------------- //
export const CLEAN_USER_STATE = "CLEAN_USER_STATE"
export const SET_USER_DATA = "SET_USER_DATA"
export const SET_SUBSCRIPTION_DATA = "SET_SUBSCRIPTION_DATA"

const actions = {
  [CLEAN_USER_STATE]({commit}) {
    commit(MUTATIONS_TYPES.CLEAN_USER_STATE)
  },
  [SET_USER_DATA]({commit}, userData) {
    commit(MUTATIONS_TYPES.SET_USER_DATA, userData)
  },
  [SET_SUBSCRIPTION_DATA]({commit}, subscriptionData) {
    commit(MUTATIONS_TYPES.SET_SUBSCRIPTION_DATA, keysToCamel(subscriptionData))
  },
}

export default {
  mutations,
  getters,
  actions,
  state,
}